import { useMemo, type ReactNode, type Ref } from "react";
import { LockedAutocomplete } from "@/components/LockedAutocomplete";
import type { AutocompleteOption, LockedAutocompleteHandle } from "@/components/LockedAutocomplete";
import { filterArtikelSuggestions } from "@/pages/artikel/artikelSuggest";

interface ArtikelSuggestFieldProps {
  value: string;
  onChange: (value: string) => void;
  suggestions: string[];
  label?: ReactNode;
  hint?: ReactNode;
  placeholder?: string;
  disabled?: boolean;
  fieldRef?: Ref<LockedAutocompleteHandle>;
}

export function ArtikelSuggestField({
  value,
  onChange,
  suggestions,
  label,
  hint,
  placeholder = "Vorhandenen wählen oder neu eingeben",
  disabled,
  fieldRef,
}: ArtikelSuggestFieldProps) {
  const selected = useMemo((): AutocompleteOption<string> | null => {
    const raw = value.trim();
    if (!raw) return null;
    return { key: raw, label: raw, value: raw };
  }, [value]);

  return (
    <div className="[&_.eh-input]:text-sm">
      <LockedAutocomplete<string>
        ref={fieldRef}
        label={label}
        hint={hint}
        placeholder={placeholder}
        value={selected}
        disabled={disabled}
        minChars={0}
        allowFreeText
        allowEditLocked={() => true}
        emptyText="Kein Treffer – Eingabe wird als neuer Wert übernommen."
        loadOptions={async (q) =>
          filterArtikelSuggestions(suggestions, q).map((item) => ({
            key: item,
            label: item,
            value: item,
          }))
        }
        onChange={(opt) => onChange(opt?.value ?? "")}
      />
    </div>
  );
}
